import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.06873 4C8.42716 4 8.6286 4.41243 8.40824 4.69512L6.08951 7.66969C5.91716 7.89078 5.58284 7.89078 5.41049 7.66969L3.09176 4.69512C2.8714 4.41243 3.07284 4 3.43127 4H8.06873Z",
		fill: "currentColor"
	})
});
export default SvgTriangleFilled;
